<template>
  <div class="chart-container">
    <chart height="100%" width="100%" :path="path1" :id="id1" :params="params1" />
  </div>
</template>

<script>
import Chart from '@/components/Charts/ChinaMap'


export default {
  name: 'ChinaMapChart',
  props: {
    path: {
      type: String
    }, id: {
      type: String
    }, height: {
      type: String
    }, width: {
      type: String
    }, params: {}
  },
  data() {
    return {
      path1: this.path,
      id1: this.id,
      height1: this.height,
      width1: this.width,
      params1: this.params,

    }
  },
  components: {Chart}
}
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
